export const prepareUrlWithParams = (baseUrl, endpoint, params = [])=>{
    const url = endpoint.startsWith('https://') ? endpoint : `${baseUrl}${endpoint}`;
    const urlParams = new URLSearchParams();
    for (const { key ='' , value =''  } of params){
        urlParams.append(key, value.toString());
    }
    const urlWithParams = `${url}?${urlParams.toString()}`;
    return urlWithParams;
};
export default {
    prepareUrlWithParams
};

//# sourceMappingURL=service.helpers.js.map